import { geofipsVariantsForQuery } from '../energyConsumptionSources';

/** Wastewater tables use 7-char zero-padded text geofips (e.g. 0653000, 0618100). */
export function wastewaterGeofipsVariants(geofips: number | string): string[] {
  const raw = String(geofips).replace(/^0+/, '') || '0';
  const numeric = Number(raw);
  const out = new Set<string>();

  out.add(String(geofips).padStart(7, '0'));
  out.add('0' + raw.padStart(6, '0'));

  if (Number.isFinite(numeric)) {
    for (const v of geofipsVariantsForQuery(numeric)) {
      const s = String(v).replace(/^0+/, '') || '0';
      out.add(String(v).padStart(7, '0'));
      out.add('0' + s.padStart(6, '0'));
    }
  }

  return Array.from(out);
}
